// extracted by mini-css-extract-plugin
export default {"MobileNavbar":"MobileNavbar_MobileNavbar__ZmRSL","Menu":"MobileNavbar_Menu__FBg+i"};